import { Integration } from '../../../../api/partner/partnerApiTypes';

export const CREATABLE_INTEGRATIONS: Integration[] = [
  Integration.MPI,
  Integration.BASELINKER,
  Integration.WEBEDI,
];

export interface Edit {
  code: string;
  partnerName: string;
  integration: Integration;
}

export type Status = 'loading' | 'ready' | 'creating';

export type CodeCheck = 'idle' | 'checking' | 'available' | 'taken';

export interface State {
  status: Status;
  codeCheck: CodeCheck;
  edit: Edit;
}

type EditSetAction = { type: 'edit/set', payload: Edit };
type CodeSuggestedAction = { type: 'code/suggested', payload: string };
type CodeCheckingAction = { type: 'code/checking' };
type CodeCheckedAction = { type: 'code/checked', payload: { code: string, available: boolean } };
type CodeCheckResetAction = { type: 'code/reset' };
type StatusSetAction = { type: 'status/set', payload: Status };
export type Action =
  | EditSetAction
  | CodeSuggestedAction
  | CodeCheckingAction
  | CodeCheckedAction
  | CodeCheckResetAction
  | StatusSetAction;

export const initialState: State = {
  status: 'loading',
  codeCheck: 'idle',
  edit: {
    code: '',
    partnerName: '',
    integration: Integration.MPI,
  },
};

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'edit/set': {
      const edit = action.payload;
      const codeChanged = edit.code.trim() !== state.edit.code.trim();

      return { ...state, edit, codeCheck: codeChanged ? 'idle' : state.codeCheck };
    }
    case 'code/suggested': {
      return {
        ...state,
        status: 'ready',
        codeCheck: 'idle',
        edit: { ...state.edit, code: action.payload },
      };
    }
    case 'code/checking': {
      return { ...state, codeCheck: 'checking' };
    }
    case 'code/checked': {
      const { code, available } = action.payload;

      if (code !== state.edit.code.trim()) {
        return state;
      }

      return { ...state, codeCheck: available ? 'available' : 'taken' };
    }
    case 'code/reset': {
      return { ...state, codeCheck: 'idle' };
    }
    case 'status/set': {
      return { ...state, status: action.payload };
    }
    default:
      return state;
  }
}

export function isCodeTaken(state: State): boolean {
  return state.codeCheck === 'taken';
}

export function isCodeVerified(state: State): boolean {
  return state.codeCheck === 'available';
}

export function needsCodeCheck(state: State): boolean {
  return state.codeCheck === 'idle';
}

export function canSubmit(state: State): boolean {
  return state.status === 'ready' && state.codeCheck !== 'taken';
}
